import React from 'react';
import WorkflowContainer from '../../containers/manufacturingmng/workflow/WorkflowContainer';

const WorkflowPage = () => {
  return <WorkflowContainer pageUrl="/workflow" />;
};

export default WorkflowPage;
